import { RocheUIPipelineChangesLaneState as e } from "./roche-pipeline-changes-track.types.js";
const f = (t, c, o) => {
  const n = t.findIndex((r) => r.id === c), i = o ? t.findIndex((r) => r.id === o) : -1;
  if (n === -1)
    return t.map(() => e.PASSED);
  const d = i === -1 ? n : Math.max(i, n);
  return t.map((r, a) => a === n ? e.CURRENT : a === i ? e.PREVIOUS : a > d ? e.FUTURE : e.PASSED);
};
export {
  f as getPipelineChangesLaneStates
};
